import { withStyles, Grid, Paper, List, ListItem, ListItemText, Divider, Button, ListItemSecondaryAction } from '@material-ui/core';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment'
import AdminSettingsTitle from '../Common/AdminSettingsTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withTranslation } from 'react-i18next';
import ChangeUsersQuantityModal from './ChangeUsersQuantityModal';
import ChangeSubscriptionModal from './ChangeSubscriptionModal';
import { updateSubscription } from '../../../../actions/globalDataAction';
import { SHOW_UPGRADE_FROM_FREE } from '../../../../actionTypes/actionTypes';
import { withMixpanel } from '../../../components/Common/withMixpanel';
import { OldPagesWrap } from '../newway/OldPagesWrap';
import { GroupLoader, NewUiWrapper } from '@tuqqi/web';
import { store } from '../../../..';

const styles = theme => ({
    loader: {
        marginLeft: 0,
        marginRight: 0
    },
    content: {
    },
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        margin: 16
    }
})

const showPaymentIntercom = () => {
    window.Intercom('show')
}

const PaymentMethod = ({ t, classes, subscription }) => <div data-intrcm-id="Subscription_t0tr81qp"><AdminSettingsTitle text={t("paymentmethod")} />
    <Paper className={classes.paperStyle}>
        <List className={classes.listStyle}>
            <ListItem>
                <ListItemText
                    primary={t("paymentmethod")}
                    secondary={"**** **** **** " + subscription.paymentMethod.cardNumber} />
                <ListItemSecondaryAction>
                    <Button onClick={showPaymentIntercom} >
                        {t("Update")}
                    </Button>
                </ListItemSecondaryAction>
            </ListItem>
            <ListItem>
                <ListItemText
                    primary={t("cardexp")}
                    secondary={subscription.paymentMethod.cardExp} />
            </ListItem>
        </List>
    </Paper>
</div>

const Invoices = ({ t, classes, subscription }) => <div data-intrcm-id="Subscription_u6921pqo"><AdminSettingsTitle text='Invoices' />
    <Paper className={classes.paperStyle}>
        <Table className={classes.table} aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell>{t('invoiceDate')}</TableCell>
                    <TableCell align="right">{t('taxinvoicenumber')}</TableCell>
                    <TableCell align="right">{t('invoicetotalamount')}</TableCell>
                    <TableCell align="right"></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {subscription.invoices.map(row => (
                    <TableRow key={row.Id}>
                        <TableCell component="th" scope="row">
                            {moment(row.invoiceDateTime).format('MMMM Do YYYY')}
                        </TableCell>
                        <TableCell align="right">{row.taxInvoiceNumber}</TableCell>
                        <TableCell align="right">{row.currency + " " + row.amount}</TableCell>
                        <TableCell align="right"><a href={row.invoiceLink} target={'_blank'}>Download</a></TableCell>

                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </Paper>
</div>

class Subscription extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoaded: false,
            isQuantityModalOpen: false,
            isSubscriptionModalOpen: false,
        }

    }

    loadData = () => {
        const { billingService, dispatch } = this.props;

        billingService.getCurrentSubscription().then((result) => {
            // Update current subscription before changing anything
            dispatch(updateSubscription(result))
            this.setState({ isLoaded: true })
        })
    }

    onSubscriptionUpdate = () => {
        this.setState({
            isQuantityModalOpen: false,
            isSubscriptionModalOpen: false
        })
        this.loadData()
    }

    componentDidMount() {
        this.loadData()
        this.props.mixpanelTrack('Viewed tier detail', {})
    }

    nextPayment = () => {

        const { subscription } = this.props;

        if(subscription.invoices && subscription.invoices.length > 0){
            return subscription.invoices[subscription.invoices.length - 1].amount
        }
        
        let usersCost = 0

        if (subscription.subscriptionType === 1) {
            usersCost = subscription.numberOfUsers * 9
        } else if (subscription.subscriptionType === 2) {
            usersCost = subscription.numberOfUsers * 29
        }

        if (subscription.billingInterval === 1) {
            usersCost = usersCost * 10 // 
        }

        return usersCost;

    }

    onUpdgradeSubscription = () => {
        const { subscription } = this.props;

        if (subscription.subscriptionType === 0) {
            //window.open("https://store.payproglobal.com/checkout?products[1][id]=57846&page-template=13546&use-test-mode=true&secret-key=3?965ABtnR&x-orguid=" + this.props.userData.profileData.org.orgUid)
            this.props.dispatch({ type: SHOW_UPGRADE_FROM_FREE })
        }
        else if (subscription.subscriptionType > 0) {
            // open popup
            this.setState({ isSubscriptionModalOpen: true });
        }
    }


    openUsersModal = () => {
        this.setState({ isQuantityModalOpen: true });
    }

    render() {

        const { classes, dispatch, t, subscription } = this.props;
        const { isLoaded, isQuantityModalOpen, isSubscriptionModalOpen } = this.state;

        return <OldPagesWrap classNameContent={classes.content} >
                {isLoaded ? <Grid spacing={16}>
                    <AdminSettingsTitle text='Current plan' />
                    <Paper className={classes.paperStyle}>
                        <List className={classes.listStyle}>
                            <ListItem>
                                <ListItemText primary={t("Subscription plan")} secondary={t("subscription_" + subscription.subscriptionType)} />
                                <ListItemSecondaryAction>
                                    {(subscription.subscriptionType <= 2) ?
                                        <Button onClick={this.onUpdgradeSubscription} >
                                            {t("Upgrade")}
                                        </Button> : null}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />

                            <ListItem>
                                <ListItemText
                                    primary={t("Subscription interval")}
                                    secondary={t('subscription_interval_' + subscription.billingInterval)} />
                            </ListItem>
                            <Divider />
                            <ListItem>
                                <ListItemText primary={"Subscription renewal date"} secondary={moment(subscription.subscriptionValidUntil).format('MMMM Do YYYY')} />
                            </ListItem>
                            <Divider />

                            <ListItem>
                                <ListItemText
                                    primary={t("paidusers")}
                                    secondary={subscription.numberOfUsers} />
                                <ListItemSecondaryAction>
                                    {subscription.subscriptionType ? <Button onClick={this.openUsersModal} >
                                        {t("Get more")}
                                    </Button> : null}
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                            {/* <ListItem>
                                <ListItemText
                                    primary={t("nextcharge")}
                                    secondary={this.nextPayment()} />
                            </ListItem> */}
                            <Divider />
                        </List>
                    </Paper>
                    {subscription.subscriptionType > 0 ? <PaymentMethod t={t} classes={classes} subscription={subscription} /> : null}
                    {subscription.subscriptionType > 0 ? <Invoices t={t} classes={classes} subscription={subscription} /> : null}
                    {subscription.subscriptionType > 0 ? <Fragment><a href="#" style={{ fontSize: 12 }} onClick={() => { window.Intercom('show') }}>
                        Unsubscribe from your current plan
                        </a><br /></Fragment> : null}

                    <ChangeUsersQuantityModal open={isQuantityModalOpen} usersNumber={subscription.numberOfUsers} currentSubscriptionType={subscription.subscriptionType} onClose={this.onSubscriptionUpdate} />
                    <ChangeSubscriptionModal open={isSubscriptionModalOpen} currentSubscription={subscription.subscriptionType} onClose={this.onSubscriptionUpdate} />
                </Grid> : <NewUiWrapper store={store} callbacks={{}}>
                    <GroupLoader className={classes.loader} />
                </NewUiWrapper>}
    </OldPagesWrap>
    }
}
const mapStateToProps = (state) => ({
    ...state.services,
    userData: state.userData,
    subscription: state.globalData.currentSubscription
})


const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    withTranslation('billing'),
    withMixpanel,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(Subscription);